export const AUDIO_LEVELS_TOPIC = 'audio.levels'

export interface AudioLevelsSnapshot {
  /** Meter-scaled input activity. Producers may publish continuous or bucketed values in the 0-5 range. */
  input: number
  /** Raw system-audio RMS. 0 when system channel has no live track. */
  system: number
  /** Wall-clock timestamp (ms) of the snapshot. */
  at: number
}

export const EMPTY_AUDIO_LEVELS: AudioLevelsSnapshot = { input: 0, system: 0, at: 0 }
